// File: frontend/src/components/common/GoogleAnalytics.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// NOTE: Apna Google Analytics Measurement ID yahan daalein (G-XXXXXXXXXX)
const TRACKING_ID = "G-9GGLCY0NZ0"; 

// Initialize once
ReactGA.initialize(TRACKING_ID);

const GoogleAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        // Jab bhi URL change ho, Pageview bhejo
        ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }, [location]);

    return null; // Ye kuch render nahi karega, bas background me chalega
};

export default GoogleAnalytics;
